import type { TourSection } from './types';

export const productImportsSections: TourSection[] = [
  {
    id: 'new',
    label: 'Nueva importación',
    steps: [
      {
        target: '[data-tour="product-imports-new"]',
        title: 'Subir XLSX',
        content:
          'Sube un archivo Excel con la plantilla base. Cada fila se procesa como create o update por SKU. El job corre en segundo plano y avisa cuando termina.',
      },
    ],
  },
  {
    id: 'filters',
    label: 'Filtros de importaciones',
    steps: [
      {
        target: '[data-tour="product-imports-filters"]',
        title: 'Filtros',
        content:
          'Filtra por estado: pendiente, en curso, completado o fallado. Los fallados se pueden reintentar desde el detalle.',
      },
    ],
  },
  {
    id: 'table',
    label: 'Listado de importaciones',
    steps: [
      {
        target: '[data-tour="product-imports-table"]',
        title: 'Jobs de importación',
        content:
          'Cada fila muestra el archivo original, estado, progreso live (procesadas / totales) y filas con error. Click en una fila para ver el detalle.',
      },
    ],
  },
];
